import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './base-cell.module.css'

type BaseCellProps = ComponentPropsWithoutRef<'div'> & {
  editing?: boolean
  disallowSelection?: boolean
}

export const BaseCell = forwardRef<HTMLDivElement, BaseCellProps>((props, ref) => {
  const {editing, disallowSelection, className, ...other} = props

  return (
    <div
      ref={ref}
      className={clsx(
        className,
        styles.Box,
        editing && styles.editingCell,
        disallowSelection && styles.disallowSelection,
      )}
      {...other}
    />
  )
})

BaseCell.displayName = 'BaseCell'
